import { useEffect, useState } from 'react'
import { Empty } from 'mk-pc'
import { useAppNavigate } from '@mkmp/core'
import { Header } from '../components/Header'
import { getMessage } from '../service'
import '../styles/main.scss'

/**
 * 消息中心
 */
export const MessageMain = () => {
  const [list, setList] = useState([] as any)
  const navigate = useAppNavigate()

  useEffect(() => {
    fetchData()
  }, [])

  /**
   *获取消息列表
   */
  const fetchData = async () => {
    const result = await getMessage()

    setList(result)
  }

  /**
   * 跳转审核中心
   * @param e
   */
  const toAudit = (e: any) => {
    if (e.type === 2) {
      navigate(`/audit`, {
        appName: 'kbsApp',
        appBaseRoute: '/kbs/'
      })
    }
  }

  return (
    <section className="message">
      <Header />
      <div className="message-content">
        <div className="message-list">
          {list.length <= 0 && <Empty title="暂无消息" />}
          {list.map((item: any) => (
            <div className="message-list__item" onClick={() => toAudit(item)}>
              <div className="icon"></div>
              <div className="content">{item.content}</div>
              <div className="time">{item.createTime}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
